export default {
  en: {
    tabs: {
      screen: 'Screen',
      letuchka: 'Daily',
    },
    settings: 'Settings',
    settingsMenu: {
      account: 'My account',
      invite: 'Invite',
      organization: 'Settings',
      users: 'Employees',
      roles: 'Access Levels',
      projectRoles: 'Project Roles',
      teams: 'Working groups',
      loyaltyProgram: 'Loyalty Program',
      payments: 'Payments',
      integrations: 'Integrations',
      notifications: 'Notifications',
      branding: 'Branding',
      leadFormPolicies: 'Lead Form Policies',
      departments: 'Departments',
      sso: 'SSO',
    },
    support: 'Support',
    signOut: {
      title: 'Sign out',
      modal: {
        text: 'Are you sure you want to sign out?',
        ok: 'Sign out',
      },
    },
    teamMode: {
      stream: 'My Stream',
      allTasks: 'All Tasks',
      calendar: 'Calendar',
      daily: 'Daily Scrum',
    },
    singleMode: {
      allTasks: 'My Tasks',
      calendar: 'Calendar',
      daily: 'Daily Scrum',
    },
    recorderLibrary: 'Video messages',
    screenshots: 'Screenshots',
    leads: 'Leads',
    analytics: 'Analytics',
  },

  ru: {
    tabs: {
      screen: 'Экран',
      letuchka: 'Летучка',
    },
    support: 'Поддержка',
    settings: 'Настройки',
    settingsMenu: {
      account: 'Мой аккаунт',
      invite: 'Пригласить',
      organization: 'Организация',
      users: 'Сотрудники',
      roles: 'Уровни доступов',
      projectRoles: 'Проектные роли',
      teams: 'Рабочие группы',
      loyaltyProgram: 'Программа лояльности',
      payments: 'Счета и оплата',
      integrations: 'Интеграции',
      notifications: 'Уведомления',
      branding: 'Брендирование',
      leadFormPolicies: 'Политики лид-форм',
      departments: 'Департаменты',
      sso: 'SSO',
    },
    signOut: {
      title: 'Выйти из аккаунта',
      modal: {
        text: 'Вы уверены, что хотите выйти из аккаунта?',
        ok: 'Выйти',
      },
    },
    teamMode: {
      stream: 'Мой поток',
      allTasks: 'Все задачи',
      calendar: 'Календарь',
      daily: 'План на день',
    },
    singleMode: {
      allTasks: 'Мои задачи',
      calendar: 'Календарь',
      daily: 'План на день',
    },
    recorderLibrary: 'Видеосообщения',
    screenshots: 'Скриншоты',
    leads: 'Лиды',
    analytics: 'Аналитика',
  },
}
